// this is an autogenerated file from DesignSystem/LeadPreview/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__DesignSystem_LeadPreview($lead_id: uuid!) {
  leads_create_patient(lead_id: $lead_id) {
    ok
  }
}

`